// extracted by mini-css-extract-plugin
module.exports = {"btn":"GradientButton_btn__fY9Qa","_arrowed":"GradientButton__arrowed__VNtXE","_disabled":"GradientButton__disabled__YniMW"};